import React from 'react';
import S3Image from '../S3Image';

const Image = (imageProps: any): React.ReactElement => {
    return <S3Image file={'business_strategy--automation.jpg'} />;
};

export default Image;
